(() => {
  // Phones/tablets: a clear touch layer over each reel so swipes scroll the page
  // instead of being swallowed by the Instagram player. A tap hands the reel to
  // the player (next tap plays it); scrolling it out of view puts the layer back.
  const touchDevice = matchMedia('(hover: none), (pointer: coarse)').matches;
  const guardObserver = touchDevice && 'IntersectionObserver' in window
    ? new IntersectionObserver(entries => entries.forEach(entry => {
        if (!entry.isIntersecting) entry.target.classList.remove('is-reel-active');
      }), {threshold: 0})
    : null;
  function addTouchGuard(media) {
    if (!touchDevice || media.querySelector('.c4-reels__touch')) return;
    const guard = document.createElement('button');
    guard.type = 'button';
    guard.className = 'c4-reels__touch';
    guard.setAttribute('aria-label', `Play reel ${media.dataset.reelNumber}`);
    guard.addEventListener('click', () => media.classList.add('is-reel-active'));
    media.append(guard);
    if (guardObserver) guardObserver.observe(media);
  }
  function initialize(section) {
    section.querySelectorAll('[data-reel-url]').forEach(media => {
      const value = media.dataset.reelUrl.trim();
      if (!value) return;
      // Accept a single link or a pasted four-link list with product notes.
      const links = [...value.matchAll(/(?:https?:\/\/)?(?:www\.)?instagram\.com\/(?:p|reel|reels)\/([A-Za-z0-9_-]+)(?=[/?#\s]|$)/gi)];
      const match = links.length > 1 ? links[Number(media.dataset.reelNumber) - 1] : links[0];
      if (!match) {
        const note = media.querySelector('.c4-reels__placeholder small');
        if (note) note.textContent = 'Enter a public Instagram reel or video post link.';
        return;
      }
      const shortcode = match[1];
      const source = `https://www.instagram.com/p/${shortcode}/embed/`;
      const existing = media.querySelector('iframe');
      if (existing && existing.getAttribute('src') === source) { addTouchGuard(media); return; }
      if (existing) existing.remove();
      const instagramLink = media.querySelector('.c4-reels__instagram-link');
      if (instagramLink) instagramLink.href = `https://www.instagram.com/p/${shortcode}/`;
      const iframe = document.createElement('iframe');
      iframe.src = source;
      iframe.title = `Instagram reel ${media.dataset.reelNumber}`;
      iframe.loading = 'lazy';
      iframe.allow = 'autoplay; encrypted-media; fullscreen; picture-in-picture';
      iframe.allowFullscreen = true;
      iframe.referrerPolicy = 'strict-origin-when-cross-origin';
      iframe.setAttribute('scrolling', 'no');
      media.classList.add('has-reel');
      media.append(iframe);
      addTouchGuard(media);
    });
    if (section.dataset.initialized) return;
    section.dataset.initialized = 'true';
    const track = section.querySelector('.c4-reels__track');
    const previous = section.querySelector('[data-reel-direction="-1"]');
    const next = section.querySelector('[data-reel-direction="1"]');
    const update = () => {
      const overflows = track.scrollWidth > track.clientWidth + 2;
      previous.hidden = next.hidden = !overflows;
      previous.disabled = track.scrollLeft <= 1;
      next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
    };
    [previous, next].forEach(button => button.addEventListener('click', () => {
      const width = track.firstElementChild.getBoundingClientRect().width;
      const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      track.scrollBy({left: (width + gap) * Number(button.dataset.reelDirection), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
    }));
    track.addEventListener('scroll', update, {passive:true});
    const observer = new ResizeObserver(update);
    observer.observe(track);
    section.addEventListener('chhedas:reels:cleanup', () => observer.disconnect(), {once:true});
    update();
  }
  document.querySelectorAll('[data-four-reels]').forEach(initialize);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-four-reels]').forEach(initialize));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-four-reels]').forEach(section => section.dispatchEvent(new Event('chhedas:reels:cleanup'))));
})();
